import React from "react";

import clsx from "clsx";

import { Chip, Typography, Tooltip } from "@mui/material";

import ClipboardTooltip from "../../../../../shared/ClipboardTooltip";
import { parseDate } from "../../../../../../business/models/common/utils/clientUtils";
import { PLACEHOLDER } from "../../../../../../configurations/appConstants";
import { classes, Grid } from "../../../../styles/compact";

const CompactRadio = ({ item, onClipboardCopy }) => {
  const {
    spotName,
    spotLength,
    trafficItemStartDate,
    trafficItemEndDate,
    title,
    id
  } = item;
  return (
    <Grid container spacing={2}>
      <Grid item>
        <Tooltip
          title={
            <ClipboardTooltip onButtonClick={onClipboardCopy} text={title} />
          }
          placement="bottom-start"
        >
          <Chip
            label={
              <Typography
                id={`title_${id}`}
                name={`title_${id}`}
                className={clsx(classes.typography, classes.inheritWidth)}
                align="center"
                noWrap
              >
                {title || PLACEHOLDER}
              </Typography>
            }
            classes={{ label: classes.chipHeaderLarge }}
            className={classes.chipTraffic}
          />
        </Tooltip>
      </Grid>
      <Grid item className={classes.trafficItemGridItemHeader}>
        <Chip
          label={
            <Typography
              id={`trafficItemStartDate_${id}`}
              name={`trafficItemStartDate_${id}`}
              className={clsx(classes.typography, classes.inheritWidth)}
              align="center"
              noWrap
            >
              {parseDate(trafficItemStartDate)}
            </Typography>
          }
          classes={{ label: classes.chipHeader }}
          className={classes.chipTraffic}
        />
      </Grid>
      <Grid item className={classes.trafficItemGridItemHeader}>
        <Chip
          label={
            <Typography
              id={`trafficItemEndDate_${id}`}
              name={`trafficItemEndDate_${id}`}
              className={clsx(classes.typography, classes.inheritWidth)}
              align="center"
              noWrap
            >
              {parseDate(trafficItemEndDate)}
            </Typography>
          }
          classes={{ label: classes.chipHeader }}
          className={classes.chipTraffic}
        />
      </Grid>
      <Grid item>
        <Tooltip
          title={
            <ClipboardTooltip
              onButtonClick={onClipboardCopy}
              text={spotLength}
            />
          }
          placement="bottom-start"
        >
          <Chip
            label={
              <Typography
                id={`spotLength_${id}`}
                name={`spotLength_${id}`}
                className={clsx(classes.typography, classes.inheritWidth)}
                align="center"
                noWrap
              >
                {spotLength || PLACEHOLDER}
              </Typography>
            }
            classes={{ label: classes.chipHeader }}
            className={classes.chipTraffic}
          />
        </Tooltip>
      </Grid>
      <Grid item>
        <Tooltip
          title={
            <ClipboardTooltip onButtonClick={onClipboardCopy} text={spotName} />
          }
          placement="bottom-start"
        >
          <Chip
            label={
              <Typography
                id={`spotName_${id}`}
                name={`spotName_${id}`}
                className={clsx(classes.typography, classes.inheritWidth)}
                align="center"
                noWrap
              >
                {spotName || PLACEHOLDER}
              </Typography>
            }
            classes={{ label: classes.chipHeader }}
            className={classes.chipTraffic}
          />
        </Tooltip>
      </Grid>
    </Grid>
  );
};

export default CompactRadio;
